export default __webpack_public_path__ + "static/media/chulimoges.8d9321f4.png";